import { FileExtensions, ImageExtensions, VideoExtensions } from './file-extensions';
import { trimStart } from 'lodash-es';

export const ImageFileTypes = (Object.keys(ImageExtensions) as (keyof typeof ImageExtensions)[]).reduce<{
    [P in keyof typeof ImageExtensions]: string;
}>((acc, c) => ({ ...acc, [c]: trimStart(ImageExtensions[c], '.') }), { ...ImageExtensions });

export const VideoFileTypes = (Object.keys(VideoExtensions) as (keyof typeof VideoExtensions)[]).reduce<{
    [P in keyof typeof VideoExtensions]: string;
}>((acc, c) => ({ ...acc, [c]: trimStart(VideoExtensions[c], '.') }), { ...VideoExtensions });

export const FileTypes = (Object.keys(FileExtensions) as (keyof typeof FileExtensions)[]).reduce<{
    [P in keyof typeof FileExtensions]: string;
}>((acc, c) => ({ ...acc, [c]: trimStart(FileExtensions[c], '.') }), { ...FileExtensions });
